package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.auth.ProfileTypes
import br.com.htms.inspeccaocampo.auth.UserDisplayName
import br.com.htms.inspeccaocampo.data.AcaoCorrecaoChecklist
import br.com.htms.inspeccaocampo.data.ChecklistVetoresCatalog
import br.com.htms.inspeccaocampo.data.RespostaConformidade
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.shared.ui.components.ButtonLoadingContent
import br.com.htms.inspeccaocampo.shared.ui.components.DateFieldKind
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import br.com.htms.inspeccaocampo.shared.ui.components.ItemConformidadeCard
import br.com.htms.inspeccaocampo.shared.ui.components.PreviaAntesSalvarDialog
import br.com.htms.inspeccaocampo.shared.ui.components.RotuloConformidade
import br.com.htms.inspeccaocampo.shared.ui.components.SignatureField
import br.com.htms.inspeccaocampo.shared.ui.components.SignaturePadScreen
import br.com.htms.inspeccaocampo.ui.FormPrevia
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.TituloSecao
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import kotlinx.coroutines.launch

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SharedChecklistVetoresScreen(controller: AppController) {
    val form by controller.checklistForm.collectAsState()
    val erros by controller.erros.collectAsState()
    val mensagem by controller.mensagem.collectAsState()
    val obrasAtivas by controller.obrasAtivas.collectAsState()
    val assinaturaEditando by controller.assinaturaEditando.collectAsState()
    val capturandoGps by controller.capturandoGps.collectAsState()

    var nomesUsuarios by remember { mutableStateOf<List<UserDisplayName>>(emptyList()) }
    val snackbar = remember { SnackbarHostState() }
    val scope = rememberCoroutineScope()
    val listState = rememberLazyListState()
    var mostrarPrevia by remember { mutableStateOf(false) }

    fun scrollSeguro(index: Int) {
        scope.launch {
            val total = listState.layoutInfo.totalItemsCount
            if (total <= 0) return@launch
            listState.animateScrollToItem(index.coerceIn(0, total - 1))
        }
    }

    LaunchedEffect(Unit) {
        controller.carregarObrasAtivas()
        nomesUsuarios = AuthApi.listUserDisplayNames().getOrElse { emptyList() }
    }
    fun nomesCom(vararg tags: String): List<Pair<String, String>> =
        nomesUsuarios
            .filter { u ->
                tags.any { tag -> u.profileTypes.any { it.equals(tag, ignoreCase = true) } }
            }
            .map { it.display }
            .filter { it.isNotBlank() }
            .distinct()
            .sorted()
            .map { it to it }
    LaunchedEffect(mensagem) {
        val msg = mensagem ?: return@LaunchedEffect
        snackbar.showSnackbar(msg)
        controller.consumirMensagem()
    }
    LaunchedEffect(erros) {
        if (erros.isEmpty()) return@LaunchedEffect
        runCatching { listState.animateScrollToItem(0) }
    }

    if (assinaturaEditando != null) {
        val campo = assinaturaEditando!!
        SignaturePadScreen(
            titulo = if (campo == "acompanhadoPor") {
                "Assinatura — Responsável pelo alojamento"
            } else {
                "Assinatura — Responsável pela inspeção"
            },
            onCancelar = { controller.fecharAssinatura() },
            onConfirmar = { token -> controller.salvarAssinaturaChecklist(campo, token) }
        )
        return
    }

    val secoes = ChecklistVetoresCatalog.secoes()
    val temNc = form.itens.any { it.resposta == RespostaConformidade.NC }
    val coordsTexto = when {
        form.latitude != null && form.longitude != null ->
            "Lat: ${form.latitude}  Lng: ${form.longitude}"
        else -> ""
    }

    Scaffold(snackbarHost = { SnackbarHost(snackbar) }) { padding ->
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(padding)
                .background(Color.Transparent)
        ) {
            br.com.htms.inspeccaocampo.ui.kit.AreaRolavel(listState, Modifier.fillMaxSize()) {
                LazyColumn(
                    state = listState,
                    modifier = Modifier.fillMaxSize(),
                    contentPadding = PaddingValues(bottom = 96.dp),
                    verticalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    item {
                        PortalOutlinedButton(
                            onClick = { controller.solicitarSaidaDoFormulario { controller.voltarAoHub() } },
                            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 8.dp)
                        ) { Text("Voltar ao hub") }
                    }
                    item {
                        Column(Modifier.padding(horizontal = 16.dp)) {
                            Text(
                                ChecklistVetoresCatalog.TITULO,
                                fontWeight = FontWeight.Bold,
                                color = PortalCores.Navy,
                                style = MaterialTheme.typography.titleMedium
                            )
                            Text(
                                ChecklistVetoresCatalog.SUBTITULO,
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant
                            )
                            Text(
                                "Conforme e não conforme pedem foto. N/A pede justificativa.",
                                style = MaterialTheme.typography.bodySmall,
                                modifier = Modifier.padding(top = 4.dp)
                            )
                        }
                    }
                    item {
                        Card(
                            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                            colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface),
                            border = PortalCores.BordaCartao
                        ) {
                            Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                                TituloSecao("1. Identificação")
                                br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                                    label = "Obra *",
                                    opcoes = obrasAtivas.map { it.nome to it.nome },
                                    selecionado = form.obra,
                                    onSelect = { v -> controller.atualizarChecklist { it.copy(obra = v) } },
                                    isError = controller.erroNoCampo("obra") != null
                                )
                                AppOutlinedTextField(
                                    value = form.endereco,
                                    onValueChange = { v -> controller.atualizarChecklist { it.copy(endereco = v) } },
                                    label = { Text("Local do alojamento *") },
                                    modifier = Modifier.fillMaxWidth(),
                                    minLines = 2,
                                    colors = FormFieldDefaults.textFieldColors(),
                                    isError = controller.erroNoCampo("endereco") != null
                                )
                                br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                                    label = "Responsável pela inspeção (ADM) *",
                                    opcoes = nomesCom(ProfileTypes.ADM),
                                    selecionado = form.inspecionadoPor.nome,
                                    onSelect = { v ->
                                        controller.atualizarChecklist {
                                            it.copy(inspecionadoPor = it.inspecionadoPor.copy(nome = v))
                                        }
                                    },
                                    isError = controller.erroNoCampo("inspecionadoPorNome") != null
                                )
                                AppOutlinedTextField(
                                    value = form.dataHorarioFormatado(),
                                    onValueChange = {},
                                    readOnly = true,
                                    label = { Text("Data") },
                                    modifier = Modifier.fillMaxWidth(),
                                    colors = FormFieldDefaults.textFieldColors()
                                )
                                AppOutlinedTextField(
                                    value = form.numeroTrabalhadores,
                                    onValueChange = { v ->
                                        controller.atualizarChecklist {
                                            it.copy(numeroTrabalhadores = v.filter { ch -> ch.isDigit() }.take(6))
                                        }
                                    },
                                    label = { Text("Número de trabalhadores *") },
                                    modifier = Modifier.fillMaxWidth(),
                                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                                    colors = FormFieldDefaults.textFieldColors(),
                                    isError = controller.erroNoCampo("numeroTrabalhadores") != null
                                )
                                br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                                    label = "Responsável pelo alojamento (ADM e TST) *",
                                    opcoes = nomesCom(ProfileTypes.ADM, ProfileTypes.TST),
                                    selecionado = form.acompanhadoPor.nome,
                                    onSelect = { v ->
                                        controller.atualizarChecklist {
                                            it.copy(acompanhadoPor = it.acompanhadoPor.copy(nome = v))
                                        }
                                    },
                                    isError = controller.erroNoCampo("responsavelAlojamento") != null
                                )
                            }
                        }
                    }
                    item {
                        Card(
                            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                            colors = CardDefaults.cardColors(containerColor = PortalCores.AzulClaro)
                        ) {
                            Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                                TituloSecao("Local (GPS)")
                                AppOutlinedTextField(
                                    value = form.localTexto.ifBlank { "Aguardando GPS..." },
                                    onValueChange = {},
                                    readOnly = true,
                                    label = { Text("Local (GPS)") },
                                    modifier = Modifier.fillMaxWidth(),
                                    colors = FormFieldDefaults.textFieldColors(),
                                    isError = controller.erroNoCampo("localGps") != null
                                )
                                if (coordsTexto.isNotBlank()) {
                                    Text(
                                        coordsTexto,
                                        style = MaterialTheme.typography.bodySmall,
                                        color = MaterialTheme.colorScheme.onSurfaceVariant
                                    )
                                }
                                PortalOutlinedButton(
                                    onClick = { controller.capturarGpsChecklist() },
                                    enabled = !capturandoGps,
                                    modifier = Modifier.fillMaxWidth()
                                ) {
                                    ButtonLoadingContent(
                                        loading = capturandoGps,
                                        loadingText = "Capturando GPS...",
                                        idleText = "Atualizar local por GPS"
                                    )
                                }
                            }
                        }
                    }
                    secoes.forEachIndexed { indice, secao ->
                        val itensSecao = form.itens.filter { it.secao == secao.titulo }
                        if (itensSecao.isEmpty()) return@forEachIndexed
                        item {
                            Text(
                                "${indice + 2}. ${secao.titulo}",
                                modifier = Modifier.padding(horizontal = 16.dp),
                                fontWeight = FontWeight.Bold,
                                color = PortalCores.Navy
                            )
                        }
                        items(itensSecao, key = { it.id }) { item ->
                            ItemConformidadeCard(
                                item = item,
                                erro = controller.erroNoCampo(item.id),
                                onResposta = { controller.definirRespostaChecklist(item.id, it) },
                                onJustificativa = { txt ->
                                    controller.atualizarItemChecklist(item.id) { atual -> atual.copy(justificativa = txt) }
                                },
                                onTirarFoto = { controller.adicionarFotoChecklistItem(item.id) },
                                onAdicionarMaisFoto = { controller.adicionarFotoChecklistItem(item.id) },
                                onGaleria = { controller.adicionarFotoChecklistItem(item.id, fromGallery = true) },
                                onRemoverFoto = { foto -> controller.removerFotoChecklistItem(item.id, foto) },
                                rotulos = RotuloConformidade.CONFORME,
                                justificativaSomenteNa = true,
                                modifier = Modifier.padding(horizontal = 16.dp)
                            )
                        }
                    }
                    if (temNc) {
                        item {
                            Card(
                                modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                                colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.secondaryContainer)
                            ) {
                                Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                                    TituloSecao("7. Plano de ação")
                                    Text(
                                        "Não conformidade / local, ação corretiva, responsável e prazo.",
                                        style = MaterialTheme.typography.bodySmall
                                    )
                                    form.acoesCorrecao.forEachIndexed { index, acao ->
                                        AcaoVetoresRow(
                                            acao = acao,
                                            onChange = { atualizado ->
                                                controller.atualizarChecklist { f ->
                                                    f.copy(
                                                        acoesCorrecao = f.acoesCorrecao.toMutableList().also {
                                                            it[index] = atualizado
                                                        }
                                                    )
                                                }
                                            },
                                            onRemover = {
                                                controller.atualizarChecklist { f ->
                                                    f.copy(acoesCorrecao = f.acoesCorrecao.filterIndexed { i, _ -> i != index })
                                                }
                                            }
                                        )
                                    }
                                    PortalOutlinedButton(
                                        onClick = {
                                            controller.atualizarChecklist { f ->
                                                f.copy(acoesCorrecao = f.acoesCorrecao + AcaoCorrecaoChecklist())
                                            }
                                        },
                                        modifier = Modifier.fillMaxWidth()
                                    ) { Text("Adicionar ação") }
                                }
                            }
                        }
                    }
                    item {
                        Card(
                            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                            colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface),
                            border = PortalCores.BordaCartao
                        ) {
                            Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                                TituloSecao("8. Orientações para tratamento")
                                ChecklistVetoresCatalog.orientacoes.forEach { (situacao, acao) ->
                                    Text(situacao, fontWeight = FontWeight.SemiBold)
                                    Text(acao, style = MaterialTheme.typography.bodySmall)
                                }
                            }
                        }
                    }
                    item {
                        Column(
                            Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                            verticalArrangement = Arrangement.spacedBy(12.dp)
                        ) {
                            TituloSecao("9. Aprovação")
                            Text("Responsável pela inspeção", fontWeight = FontWeight.SemiBold)
                            Text(form.inspecionadoPor.nome.ifBlank { "—" })
                            SignatureField(
                                label = "Assinatura do responsável pela inspeção *",
                                assinaturaToken = form.inspecionadoPor.assinatura,
                                erro = controller.erroNoCampo("inspecionadoPorAss"),
                                onClick = { controller.abrirAssinatura("inspecionadoPor") },
                                modifier = Modifier.fillMaxWidth()
                            )
                            Text("Responsável pelo alojamento", fontWeight = FontWeight.SemiBold)
                            Text(form.acompanhadoPor.nome.ifBlank { "—" })
                            SignatureField(
                                label = "Assinatura",
                                assinaturaToken = form.acompanhadoPor.assinatura,
                                erro = null,
                                onClick = { controller.abrirAssinatura("acompanhadoPor") },
                                modifier = Modifier.fillMaxWidth()
                            )
                            AppDateTextField(
                                value = form.dataVerificacao,
                                onValueChange = { v -> controller.atualizarChecklist { it.copy(dataVerificacao = v) } },
                                label = "Data da verificação das correções",
                                kind = DateFieldKind.DATE
                            )
                        }
                    }
                    if (erros.isNotEmpty()) {
                        item {
                            Card(
                                modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                                colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.errorContainer)
                            ) {
                                Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                                    Text("Corrija os campos obrigatórios:", fontWeight = FontWeight.Bold)
                                    erros.take(8).forEach { erro ->
                                        Text(
                                            text = "• ${erro.mensagem}",
                                            color = MaterialTheme.colorScheme.onErrorContainer,
                                            textDecoration = TextDecoration.Underline,
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .clickable { scope.launch { listState.animateScrollToItem(0) } }
                                                .padding(vertical = 4.dp)
                                        )
                                    }
                                    if (erros.size > 8) Text("... e mais ${erros.size - 8}")
                                }
                            }
                        }
                    }
                    item {
                        PortalButton(
                            onClick = { mostrarPrevia = true },
                            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp)
                        ) { Text("Prévia e salvar") }
                    }
                }
            }
            Column(
                modifier = Modifier.align(Alignment.BottomEnd).padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                FloatingActionButton(
                    onClick = { scrollSeguro(0) },
                    containerColor = MaterialTheme.colorScheme.primaryContainer
                ) { Text("Início", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelSmall) }
                FloatingActionButton(
                    onClick = { scrollSeguro((listState.layoutInfo.totalItemsCount - 1).coerceAtLeast(0)) },
                    containerColor = MaterialTheme.colorScheme.primaryContainer
                ) { Text("Fim", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelSmall) }
            }
        }
    }

    if (mostrarPrevia) {
        PreviaAntesSalvarDialog(
            linhas = FormPrevia.vetores(form),
            onConfirmar = { controller.validarESalvarChecklist() },
            onDismiss = { mostrarPrevia = false }
        )
    }
}

@Composable
private fun AcaoVetoresRow(
    acao: AcaoCorrecaoChecklist,
    onChange: (AcaoCorrecaoChecklist) -> Unit,
    onRemover: () -> Unit
) {
    Column(
        modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        AppOutlinedTextField(
            value = acao.item,
            onValueChange = { onChange(acao.copy(item = it)) },
            label = { Text("Não conformidade / local") },
            modifier = Modifier.fillMaxWidth(),
            colors = FormFieldDefaults.textFieldColors()
        )
        AppOutlinedTextField(
            value = acao.acao,
            onValueChange = { onChange(acao.copy(acao = it)) },
            label = { Text("Ação corretiva") },
            modifier = Modifier.fillMaxWidth(),
            minLines = 2,
            colors = FormFieldDefaults.textFieldColors()
        )
        AppOutlinedTextField(
            value = acao.responsavel,
            onValueChange = { onChange(acao.copy(responsavel = it)) },
            label = { Text("Responsável") },
            modifier = Modifier.fillMaxWidth(),
            colors = FormFieldDefaults.textFieldColors()
        )
        AppDateTextField(
            value = acao.prazo,
            onValueChange = { onChange(acao.copy(prazo = it)) },
            label = "Prazo / conclusão",
            kind = DateFieldKind.DATE
        )
        PortalOutlinedButton(onClick = onRemover, modifier = Modifier.fillMaxWidth()) {
            Text("Remover ação")
        }
    }
}
